/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
import { useMutation } from '@apollo/client';
import Button from '@mui/material/Button';
import React, { useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from '../../config';
import { SEND_CONTACT_FORM } from '../../helpers/graphql/contactform';

export default function ContactForm(props) {
  const { messagePlaceholder } = props;

  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null },
  });

  const [inputs, setInputs] = useState({
    email: '',
    message: '',
    subject: props.subject || '',
    captcha: '',
  });

  useEffect(() => {
    if (props.subject) {
      const newInputs = inputs;
      newInputs.subject = props.subject;
      setInputs(newInputs);
    }
  }, [props]);

  const [sendContactForm] = useMutation(SEND_CONTACT_FORM);

  const handleOnChange = e => {
    e.persist();
    setInputs(prev => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
    setStatus({
      submitted: false,
      submitting: false,
      info: { error: false, msg: null },
    });
  };

  const handleOnSubmit = async e => {
    e.preventDefault();
    setStatus(prevStatus => ({ ...prevStatus, submitting: true }));
    const { email, message, subject, captcha } = inputs;
    if (!captcha) {
      setStatus({
        info: { error: true, msg: 'Captcha is required' },
      });
    } else if (!message) {
      setStatus({
        info: { error: true, msg: 'Message is required' },
      });
    } else if (!email) {
      setStatus({
        info: { error: true, msg: 'Email is required' },
      });
    } else
      sendContactForm({
        variables: { contactForm: { email, message, subject, captcha } },
      }).then(({ data }) => {
        if (data.contactForm.success) {
          setStatus({
            submitted: true,
            submitting: false,
            info: { error: false, msg: data.contactForm.message },
          });
          setInputs({
            email: '',
            message: '',
            subject: '',
            captcha: '',
          });
        } else {
          setStatus({
            info: { error: true, msg: data.contactForm.message },
          });
        }
      });
  };

  const handleRecaptcha = recaptchaChange => {
    setInputs(prev => ({
      ...prev,
      captcha: recaptchaChange,
    }));
  };

  return (
    <div>
      {(!status.info.error && status.info.msg && (
        <div className="alert alert-success">{status.info.msg}</div>
      )) || (
        <form onSubmit={handleOnSubmit}>
          <div className="form-group">
            <label htmlFor="email">Your Email</label>
            <input
              id="email"
              type="email"
              onChange={handleOnChange}
              required
              value={inputs.email}
              className="form-control"
              maxLength={100}
            />
          </div>
          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <input
              maxLength={100}
              disabled={props.subject}
              id="subject"
              type="subject"
              onChange={handleOnChange}
              required
              value={props.subject || inputs.subject}
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              maxLength={5000}
              id="message"
              onChange={handleOnChange}
              required
              value={inputs.message}
              className="form-control"
              placeholder={messagePlaceholder}
            />
          </div>
          <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} onChange={handleRecaptcha} />
          <Button
            variant="contained"
            color="primary"
            type="submit"
            className="btn-square btn-square-primary mt-3"
            disabled={status.submitting}
          >
            {!status.submitting
              ? !status.submitted
                ? 'Send'
                : 'Sent'
              : 'Sending...'}
          </Button>
        </form>
      )}
      {status.info.error && (
        <div className="alert alert-danger mt-2">Error: {status.info.msg}</div>
      )}
    </div>
  );
}
